/**
 * Checks if an offer should be blocked based on provided subID values
 * Checks only the sub IDs that are provided in the array
 * @param {ListingOffers} offer - The offer object
 * @param {Array<string>} subIdValues - Array containing sub ID values [sub1Value?, sub2Value?, sub3Value?]
 * @returns {boolean} true if offer should be blocked (skip), false if offer should be shown
 */
export function hasBlockedSubId(offer, subIdValues) {
  if (!offer?.blocked_subids || typeof offer.blocked_subids !== 'object') {
    return false
  }

  if (!Array.isArray(subIdValues)) {
    return false
  }

  // Array mapping indices to sub keys
  const subKeys = ['sub1', 'sub2', 'sub3']

  // Check each provided subID value
  for (let i = 0; i < subIdValues.length && i < 3; i++) {
    const subIdValue = subIdValues[i]

    // Skip if value is falsy (null, undefined, empty string)
    if (!subIdValue) {
      continue
    }

    const subKey = subKeys[i]
    const blockedValues = offer.blocked_subids[subKey]
    if (Array.isArray(blockedValues) && blockedValues.includes(subIdValue)) {
      return true
    }
  }

  return false
}
